<script setup lang="ts">
import { RouterView } from 'vue-router';
import { Toaster } from '@/components/ui/sonner'
import EnvBadge from '@/components/EnvBadge.vue'
import 'vue-sonner/style.css'
</script>

<template>
  <EnvBadge />
  <Toaster rich-colors />
  <RouterView />
</template>
